module.exports = __webpack_public_path__ + "a62ad62f354af546c5d9df10b183f995.svg";